// noinspection GraphQLUnresolvedReference

export const getFrameTexture = /*GraphQL */ `
    query GetFrameTexture($id: [QueryArgument]) {
        asset(id: $id) {
            ... on images_Asset {
                url
                title
                width
                height
            }
        }
    }
`;

export const listChairFrameOptions = /*GraphQL*/ `
    query ListChairFrameOptions($id: [QueryArgument]) {
        chairEntries(id: $id) {
            ... on variant_Entry {
                frames {
                    ... on framesBlock_Entry {
                        id
                        frameCost
                        frame {
                            ... on frame_Entry {
                                id
                                frameName
                                textures {
                                    ... on texturesBlock_Entry {
                                        shininess
                                        textureName
                                        cost
                                        description
                                        texture {
                                            ... on images_Asset {
                                                id
                                                url
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
